/** A clip's length or position as m:ss, the way WhatsApp shows it */
export const formatMediaDuration = (seconds: number) => {
  const safe = Number.isFinite(seconds) ? Math.max(seconds, 0) : 0;
  const mins = Math.floor(safe / 60);
  const secs = Math.floor(safe % 60);

  return `${mins}:${secs.toString().padStart(2, "0")}`;
};
